import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SortDirective } from './shared-directives/sort.directives';
import { PhoneMaskDirective } from './shared-directives/phonemask.directives';

@NgModule({
  declarations: [
    SortDirective,
    PhoneMaskDirective
  ],
  imports: [
    RouterModule,
    CommonModule,

  ],
  exports: [
    SortDirective,
    PhoneMaskDirective,
    RouterModule,
    CommonModule,

  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class SharedDirectivesModule { }
